// Serwis obsługujący zarządzanie stacjami preselekcji (lokalizacje + pasy ruchu).
import { fetchWrapper } from "@/helpers/fetch-wrapper";
import FiltersService from "@/services/FiltersService";

const API = process.env.VUE_APP_API_URL;

class LocationsService {
  /**
   * Pobiera listę lokalizacji (z licznikiem X-Total-Count).
   * @param {number} page
   * @param {number} limit
   */
  async getLocationList(page = 1, limit = 100) {
    const params = new URLSearchParams({ page, limit });
    return fetchWrapper.getWithCount(`${API}/locations?${params.toString()}`);
  }

  /**
   * Pobiera pełne dane pojedynczej lokalizacji na potrzeby edycji (wszystkie pola edytowalne + pasy).
   * @param {number} id
   */
  async getLocation(id) {
    return fetchWrapper.get(`${API}/locations/${id}`);
  }

  /**
   * Ustawia zbiór stacji preselekcji, których dane użytkownik aktualnie obserwuje.
   *
   * Backend odwzorowuje ten zbiór w rejestrze aktywności: otwiera wpis dla stacji nowo obserwowanych,
   * zamyka dla tych, których w zbiorze zabrakło. Pusty zbiór wylogowuje ze wszystkich stacji.
   *
   * @param {number[]} locationIds Identyfikatory obserwowanych stacji preselekcji.
   */
  async syncLoginToLocations(locationIds) {
    return fetchWrapper.put(`${API}/locations/login`, { locations: locationIds });
  }

  /**
   * Pobiera listę klas dokładności (do wyboru przy definiowaniu pasa ruchu).
   */
  async getAccuracyClasses() {
    return fetchWrapper.get(`${API}/accuracy-classes`);
  }

  /**
   * Pobiera listę grup ról (do wyboru, które grupy mają widzieć lokalizację).
   * Endpoint respektuje tenant/uprawnienia zalogowanego administratora.
   */
  async getGroupRoles() {
    return fetchWrapper.get(`${API}/roles?orderDirection=asc`);
  }

  /**
   * Tworzy nową lokalizację wraz z pasami ruchu.
   * @param {object} payload - dane lokalizacji (z zagnieżdżoną tablicą `lanes`).
   */
  async addLocation(payload) {
    const result = await fetchWrapper.post(`${API}/locations`, payload);
    // Lista lokalizacji jest cache'owana w FiltersService — po zmianie musi zostać pobrana na nowo.
    FiltersService.invalidateLocations();
    return result;
  }

  /**
   * Aktualizuje istniejącą lokalizację wraz z pasami ruchu.
   * @param {number} id
   * @param {object} payload
   */
  async updateLocation(id, payload) {
    const result = await fetchWrapper.put(`${API}/locations/${id}`, payload);
    FiltersService.invalidateLocations();
    return result;
  }

  /**
   * Usuwa pojedynczą lokalizację.
   * @param {number} id
   */
  async deleteLocation(id) {
    const result = await fetchWrapper.delete(`${API}/locations/${id}`);
    FiltersService.invalidateLocations();
    return result;
  }

  /**
   * Usuwa wiele lokalizacji naraz.
   * @param {number[]} ids
   */
  async deleteLocations(ids) {
    const result = await fetchWrapper.post(`${API}/locations/bulk-delete`, ids);
    FiltersService.invalidateLocations();
    return result;
  }
}

// Eksport pojedynczej instancji serwisu.
export default new LocationsService();
